import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16627f31"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form-draft-action"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OioButton = _resolveComponent("OioButton")!

  return (!_ctx.invisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_OioButton, {
          type: "primary",
          loading: _ctx.saveLoading,
          disabled: _ctx.saveLoading,
          onClick: _ctx.saveFormData
        }, {
          default: _withCtx(() => [
            _createTextVNode("保存草稿")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"]),
        _createVNode(_component_OioButton, {
          type: "primary",
          loading: _ctx.backLoading,
          disabled: _ctx.backLoading,
          onClick: _ctx.backFormData
        }, {
          default: _withCtx(() => [
            _createTextVNode("还原草稿")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ]))
    : _createCommentVNode("", true)
}